export const inc = (s) => s + 1;
export const dec = (s) => s - 1;
export const decAbs = (s) => (s > 0 ? s - 1 : 0);
// alias
export const show = inc;
export const hide = decAbs;
//# sourceMappingURL=number.js.map